export const RELATION_ICONS = new Map([
  ["relative", "people"],
  ["business_partners", "hands"],
  ["companies", "company"],
  ["corporate", "company"],
  ["business_partners", "hands"],
  ["search_partners", "hands"],
  ["search_companies", "company"],
  ["company_partner", "hands"],
]);

export const RELATION_COLORS = new Map([
  ["relative", "#EDFFDE"],
  ["business_partners", "#FFDEDE"],
  ["companies", "#FFF2DE"],
  ["corporate", "#FFF2DE"],
  ["companies", "#FFF2DE"],
  ["search_partners", "#FFDEDE"],
  ["search_companies", "#FFF2DE"],
  ["company_partner", "#FFDEDE"],
]);
